import * as React from "react"
import { graphql } from "gatsby"

import Layout from "@components/layout/layout"
import Seo from "@components/layout/seo"
import HomeHero from "@components/homeHero"
import IntroTable from "@components/introTable"
import SideImageWide from "@components/sideImageWide"
import SimpleCtaSection from "@components/simpleCtaSection"

const IndexPage = ({ data }) => {
  const {
    heroData,
    introTableData,
    sideImageData1,
    sideImageData2,
    ctaSectionData,
  } = data.pageData

  return (
    <Layout>
      <HomeHero {...heroData} />
      <IntroTable {...introTableData} />
      <SideImageWide {...sideImageData1} />
      <SideImageWide {...sideImageData2} />
      <SimpleCtaSection {...ctaSectionData} />
    </Layout>
  )
}

export const Head = ({ data }) => {
  const { seoData } = data.pageData
  return <Seo {...seoData} />
}

export default IndexPage

export const pageQuery = graphql`
  query {
    pageData: indexPageJson {
      seoData: seo {
        title
        description
      }
      heroData: hero {
        topTitle
        topText
        bottomText
        bottomTitle
      }
      introTableData: introTable {
        sideTitle
        title
        items {
          icon {
            publicURL
          }
          title
          text
          url
        }
        cta {
          text
          url
        }
      }
      sideImageData1: sideImage1 {
        sideTitle
        title
        titleLarge
        text
        cta {
          text
          url
        }
        imageData: image {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        imageMobileData: imageMobile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        imageAlign
        imageAlt
      }
      sideImageData2: sideImage2 {
        sideTitle
        title
        titleLarge
        text
        cta {
          text
          url
        }
        imageData: image {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        imageMobileData: imageMobile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        imageAlign
        imageAlt
      }
      ctaSectionData: ctaSection {
        title
        cta {
          text
          url
        }
        variant
      }
    }
  }
`
